import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService implements OnDestroy {

  public loaderSubject = new Subject<boolean>();
  constructor() { 

  }

  ngOnDestroy(): void {
   this.loaderSubject.unsubscribe();
  }

  ShowLoader(){
    this.loaderSubject.next(true);
  }

  HideLoader(){
    this.loaderSubject.next(false);
  }
}
